export default __webpack_public_path__ + "static/media/kn.43bc298c.svg";